import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom"
import { fetchCampaign, markCampaignCompleted, sendCampaignForApprovalRequest } from "slices/campaigns/thunk";
import { AppDispatch, RootState } from "store";
import { copyToClipboard, formatAmount, isValidURL, safeTextFromHTML, sanitizeURLs } from "utils/helpers";
import DOMPurify from 'dompurify';
import { PRIVILEGE } from "constants/privilege";
import AccessControl from "wrappers/AccessControl";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { setHeaderCampaignData } from "slices/ui/reducer";
import CalendarIcon from "assets/icons/CalendarIcon";
import FollowersIcon from "assets/icons/FollowersIcon";
import InfluencerIcon from "assets/icons/InfluencerIcon";
import LocationIcon from "assets/icons/LocationIcon";
import BirthdayIcon from "assets/icons/BirthdayIcon";
import LanguagesIcon from "assets/icons/LanguagesIcon";
import withAccessControl from "hoc/withAccessControl";
import Avatar from "react-avatar";
import ChartsIcon from "assets/icons/mono/ChartsIcon";
import CheckedIcon from "assets/icons/mono/CheckedIcon";
import useDocumentTitle from "hooks/useDocumentTitle";
// import CampaignPaymentsOffcanvas from "Components/campaigns/CampaignPaymentsOffcanvas";
import { fetchCampaignGigsThunk, fetchCampaignMilestonesThunk } from "slices/campaigns/milestones/thunk";
import { Button, Input, InputGroup, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, UncontrolledTooltip } from "reactstrap";
import { noop } from "lodash";
// import MilestoneForm from "Components/campaigns/collaborations/milestones/MilestoneForm";
import { GigType, Milestone } from "types/campaign/collaborations";
// import { copyCampaign } from "services/api/campaign";
import { refetchCampaignLists } from "slices/campaigns/reducer";
import { allowedAttr, allowedTags, CREATOR_APP_URL } from "constants/global";
import CampaignInfoOriginal from "./Edit/CampaignInfo";
import { fetchCampaignDetails } from "slices/campaigns/details/thunk";
import { fetchCampaignRequirement } from "slices/campaigns/requirements/thunk";
import CampaignDeliverablesOriginal from "./Edit/CampaignDeliverables";
import CampaignProductOriginal from "./Edit/CampaignProduct";
import { CampaignDetail } from "types/campaign";
import CampaignImageSlider from "Components/campaigns/CampaignImageSlider";
import Loader from "Components/Common/Loader";
import DollarIcon from "assets/icons/DollarIcon";
import { FlagImage } from "react-international-phone";
import { useCountries } from "hooks/useCountries";
const CampaignInfo = CampaignInfoOriginal as any;
const CampaignDeliverables = CampaignDeliverablesOriginal as any;
const CampaignProduct = CampaignProductOriginal as any;

export const campaignIconSVG = `<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="40" cy="40" r="40" fill="#F1F5F4"/>
<path d="M24.6328 31.4951H30.9178V43.9076H24.6328C24.235 43.9076 23.8535 43.7496 23.5722 43.4683C23.2908 43.187 23.1328 42.8054 23.1328 42.4076V32.9951C23.1328 32.5973 23.2908 32.2158 23.5722 31.9345C23.8535 31.6532 24.235 31.4951 24.6328 31.4951Z" stroke="#0069AD"/>
<path d="M30.918 43.9075V31.495C30.918 31.495 34.1955 31.57 39.648 31.495C45.1005 31.42 51.483 27.97 55.6305 24.445C55.7389 24.3522 55.8716 24.2923 56.013 24.2723C56.1543 24.2523 56.2984 24.2731 56.4284 24.3321C56.5583 24.3912 56.6687 24.4861 56.7466 24.6057C56.8244 24.7254 56.8666 24.8647 56.868 25.0075V50.425C56.8676 50.5649 56.8282 50.702 56.754 50.8206C56.6799 50.9393 56.574 51.0348 56.4484 51.0965C56.3227 51.1581 56.1824 51.1834 56.0431 51.1694C55.9039 51.1555 55.7714 51.1028 55.6605 51.0175C52.9905 48.9175 46.3455 44.2225 39.9105 44.0275C36.1455 43.9075 33.1005 43.9075 30.918 43.9075Z" stroke="#0069AD"/>
<path d="M33.4672 55.75H29.8672C29.4694 55.75 29.0878 55.592 28.8065 55.3107C28.5252 55.0294 28.3672 54.6479 28.3672 54.25L27.6172 43.915H34.2172L34.9672 54.25C34.9672 54.6479 34.8092 55.0294 34.5278 55.3107C34.2465 55.592 33.865 55.75 33.4672 55.75Z" fill="#BBD8ED" stroke="#0069AD"/>
<line x1="30.8999" y1="32" x2="30.8999" y2="43.4" stroke="#00A7E4"/>
</svg>
`

const Campaign = () => {

    useDocumentTitle("Campaign");

    const { campaignId } = useParams();
    const dispatch: AppDispatch = useDispatch();

    const campaignData = useSelector((state: RootState) => state.campaigns.items?.[campaignId!]);

    const languages = useSelector((state: RootState) => state.master.languages);
    const { countries } = useCountries();

    const campaign: CampaignDetail | null = campaignData?.data ?? null;
    const loading = useSelector((state: RootState) => state.campaigns.loading);
    const countryCode = campaign?.campaign?.country;
    const countryOption = countries.find(
        (country) => country.value === (countryCode || "").toUpperCase()
    );

    const specificationItems = [
        !!campaign?.campaign.posted_on,
        // !!campaign?.campaign.strategy,
        !!campaign?.campaign.budget,
        !!campaign?.campaign?.requirements?.age?.min,
        !!(campaign?.campaign?.requirements?.gender && campaign?.campaign?.requirements?.gender !== 'A'),
        !!Number(campaign?.campaign?.barter_budget),
        !!(campaign?.campaign?.requirements?.audience_gender && campaign?.campaign?.requirements?.audience_gender !== 'A'),
    ]

    const [activeTab, setActiveTab] = useState('overview');

    const campaignMilestones = useSelector((state: RootState) => state.campaignMilestones.items[campaignId!])

    const milestonesData = campaignMilestones?.milestonesData;
    const gigTypes = milestonesData?.gig_types ?? [];

    const [milestones, setMilestones] = useState<Milestone[]>([]);
    const [campaignMilestone, setCampaignMilestone] = useState<Milestone | null>(null);
    const [milestoneGigType, setMilestoneGigType] = useState<GigType | null>(null);

    const navigate = useNavigate();
    const [shareWithCreatorsModalOpen, setShareWithCreatorsModalOpen] = useState(false);
    const [campaignLinkCopied, setCampaignLinkCopied] = useState(false);
    const campaignRequirement = useSelector((state: RootState) => state.campaignRequirements.items[campaignId!])
    const campaignRequirements = campaignRequirement?.campaign_requirement?.requirement?.details || {};
    useEffect(() => {
        if (milestones.length > 0) {
            setCampaignMilestone(milestones[0]);
        }
    }, [milestones])

    useEffect(() => {
        if (campaignMilestone && gigTypes.length > 0) {
            const gigType = gigTypes.find(type => type.id === campaignMilestone.gig_type_id);
            setMilestoneGigType(gigType || null);
        }
    }, [campaignMilestone, gigTypes])

    useEffect(() => {
        let timeout: NodeJS.Timeout;
        if (campaignLinkCopied) {
            timeout = setTimeout(() => {
                setCampaignLinkCopied(false);
            }, 2000);
        }
        return () => clearTimeout(timeout);
    }, [campaignLinkCopied])

    useEffect(() => {
        if (milestonesData?.milestones) {
            setMilestones(milestonesData.milestones);
        }
    }, [milestonesData])

    const fetchCampaignMilestones = async () => {
        if (campaignId) {
            await dispatch(fetchCampaignGigsThunk(campaignId!));
            await dispatch(fetchCampaignMilestonesThunk(campaignId!)).unwrap()
        }
    }

    useEffect(() => {
        fetchCampaignMilestones();
    }, [campaignId, dispatch]);


    useEffect(() => {
        if (campaignId) {
            dispatch(fetchCampaign({ campaignId }));
            dispatch(fetchCampaignDetails(campaignId))
            dispatch(fetchCampaignRequirement(campaignId))
        }

    }, [dispatch, campaignId])

    const getSliderImages = () => {
        let slider_images = [];
        if (campaign?.campaign?.hero_img_url) slider_images.push(campaign.campaign.hero_img_url);

        if (Array.isArray(campaign?.campaign?.gallery_images)) {
            slider_images.concat(campaign.campaign.gallery_images);
        }

        return slider_images;
    }


    const markCompleted = async () => {
        if (!campaignId) return;

        const result = await Swal.fire({
            title: "Are you sure you want to mark campaign as completed?",
            text: "We hope that the campaign is successfully completed. Please note that all the pending applications will be automatically rejected.",
            iconHtml: campaignIconSVG,
            showCancelButton: true,
            confirmButtonText: "Completed",
            cancelButtonText: "Cancel",
            reverseButtons: true
        });

        if (result.isConfirmed) {
            try {
                await dispatch(markCampaignCompleted({ campaignId })).unwrap();
                toast.success("Campaign marked as completed successfully.")
                dispatch(refetchCampaignLists());
            } catch (error: any) {
                toast.error(error.message || "Failed to mark the campaign as completed.")
            }
        }

    }


    const sendForApproval = async () => {
        if (!campaignId) return;

        const valid = await validateCampaign();
        if (!valid) return;

        const result = await Swal.fire({
            title: "Are you sure you want to submit this campaign?",
            text: "We hope that you have filled all the data correctly",
            iconHtml: campaignIconSVG,
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Yes, Submit",
            reverseButtons: true
        });

        if (result.isConfirmed) {
            try {
                await dispatch(sendCampaignForApprovalRequest({ campaignId })).unwrap();
                toast.success("Campaign sent for approval!")
                dispatch(refetchCampaignLists());
            } catch (error: any) {
                toast.error(error.message || "Failed to request campaign approval.")
            }
        }

    }

    // const copyToNewCampaign = async () => {
    //     if (!campaignId) return;

    //     const result = await Swal.fire({
    //         title: "Are you sure you want to copy this to new campaign?",
    //         text: "This will create a new campaign with the same details. Continue?",
    //         iconHtml: campaignIconSVG,
    //         showCancelButton: true,
    //         confirmButtonColor: "#3085d6",
    //         confirmButtonText: "Yes, Copy",
    //         reverseButtons: true
    //     });

    //     if (result.isConfirmed) {
    //         try {
    //             Swal.fire({
    //                 title: "Copying...",
    //                 html: `
    //             <div class="d-flex flex-column align-items-center">
    //                 <div style="margin-bottom: 1rem;">
    //                     <div class="swal2-loader" data-button-to-replace="swal2-confirm swal2-styled" style="display: flex;"></div>
    //                 </div>
    //                 <div>Please wait while we copy the campaign.</div>
    //             </div>
    //           `,
    //                 allowOutsideClick: false,
    //                 allowEscapeKey: false,
    //                 showConfirmButton: false,
    //                 showCancelButton: false,
    //             });

    //             const campaign = await copyCampaign(campaignId, agencyId);
    //             dispatch(refetchCampaignLists());
    //             if (campaign) {
    //                 navigate(`/campaign/${campaign.uuid}`)
    //             }
    //             Swal.close();
    //             toast.success("Campaign copied!");
    //         } catch (error: any) {
    //             Swal.close();
    //             toast.error(error.message || "Failed to copy campaign.");
    //         }
    //     }
    // };


    useEffect(() => {
        if (campaign) {
            dispatch(setHeaderCampaignData({ campaign, detailPage: true }));
        }

        return () => {
            if (campaign) {
                dispatch(setHeaderCampaignData({ campaign: null, detailPage: false }));
            }
        };
    }, [campaign, dispatch]);


    useEffect(() => {
        if (campaignData && campaignData?.data?.campaign?.mode === 'offline') {
            navigate(`/campaign/${campaignId}/insights`)
        }
    }, [campaignData])

    const extraColumnRequired = () => {
        return !(specificationItems.filter((spec) => spec === true).length % 2 === 0)
    }

    const getGigType = (gigTypeId: number) => {
        return milestonesData?.gig_types.find((g) => g.id === gigTypeId) || null;
    }

    const validateCampaign = async () => {
        if (!campaign || !campaignMilestone || !milestoneGigType) return false;

        const newErrors: Record<string, Record<string, string>> = {};
        if (['product_review', 'store_visit'].includes(milestoneGigType?.slug ?? '')) {
            if (campaignMilestone?.specifications?.purchase_required === undefined) {
                newErrors['gigs']['purchase_required'] = 'Please select a product delivery method.';
            }
            if (milestoneGigType?.slug === 'product_review') {
                if (!campaignMilestone?.maximum_gigs || campaignMilestone?.maximum_gigs <= 0) {
                    newErrors['gigs']['maximum_gigs'] = 'Please enter the number of products to review.';
                }
            }
            if (milestoneGigType?.slug === 'store_visit' && !campaignMilestone?.specifications?.gig_selection && !campaignMilestone?.specifications?.store_name) {
                newErrors['gigs']['store_name'] = `Store name is required.`;
            }
            if (milestoneGigType?.slug === 'product_review' && !campaignMilestone?.specifications?.gig_selection) {
                if (!campaignMilestone?.specifications?.website_url) {
                    newErrors['gigs']['website_url'] = `Website URL is required.`;
                }
                if (campaignMilestone?.specifications?.website_url && !isValidURL(campaignMilestone?.specifications?.website_url ?? '')) {
                    newErrors['gigs']['website_url'] = `Please enter a valid URL.`;
                }
            }
        }

        if (!campaignRequirements?.gender ||
            !campaignRequirements?.creator_count?.max ||
            Number(campaignRequirements?.creator_count?.max) <= 0 ||
            (!Array.isArray(campaignRequirements?.speciality_niches) || campaignRequirements?.speciality_niches.length === 0) ||
            Number(campaignRequirements?.follower_count?.min) <= 0
        ) {
            newErrors['creators'] = {};
        }

        const deliverables_errors: Record<string, string> = {};
        if (!campaignMilestone?.specifications?.quick_repost && (!campaignMilestone.brief || !safeTextFromHTML(campaignMilestone.brief))) {
            deliverables_errors.brief = "Milestone brief is required!";
        }

        if (!campaignMilestone?.specifications?.quick_repost && campaign?.campaign?.goal === 'conversion' && !campaignMilestone.specifications.advertiser_permission_required && !campaignMilestone.specifications.paid_partnership_label_required) {
            deliverables_errors.partnership_labeling = "Please select a partnership ads option"
        }

        if (!campaignMilestone?.specifications?.quick_repost && campaign?.campaign?.goal === 'conversion' && campaignMilestone.specifications.paid_partnership_label_required) {
            const handles = campaignMilestone.specifications?.paid_partnership_handle;
            if (!Array.isArray(handles) || handles.length !== 1) {
                deliverables_errors.paid_partnership_handle = "Please add exactly one social account handle"
            }
        }

        if (campaign?.campaign?.platform === 'ig') {
            if (campaignMilestone.content_media_types.REELS && (isNaN(Number(campaignMilestone.content_media_types.REELS)) || Number(campaignMilestone.content_media_types.REELS) < 0) || Number(campaignMilestone.content_media_types.REELS) > 1) {
                deliverables_errors.content_media_types = "No of reels can only be 1 or 0";
            }
            if (campaignMilestone.content_media_types.FEED && (isNaN(Number(campaignMilestone.content_media_types.FEED)) || Number(campaignMilestone.content_media_types.FEED) < 0) || Number(campaignMilestone.content_media_types.FEED) > 1) {
                if (!deliverables_errors.content_media_type) deliverables_errors.content_media_types = '';
                deliverables_errors.content_media_types = 'Max 1 post is allowed.'
            }
            if (campaignMilestone.content_media_types.STORY && (isNaN(Number(campaignMilestone.content_media_types.STORY)) || Number(campaignMilestone.content_media_types.STORY) < 0) || Number(campaignMilestone.content_media_types.STORY) > 2) {
                if (!deliverables_errors.content_media_type) deliverables_errors.content_media_types = '';
                deliverables_errors.content_media_types += 'Max 2 stories are allowed.'
            }

            if (!campaignMilestone?.specifications?.quick_repost && (isNaN(Number(campaignMilestone?.content_media_types?.REELS)) || Number(campaignMilestone?.content_media_types?.REELS) === 0) && (isNaN(Number(campaignMilestone?.content_media_types?.FEED)) || Number(campaignMilestone?.content_media_types?.FEED) === 0) && (isNaN(Number(campaignMilestone?.content_media_types?.STORY)) || Number(campaignMilestone?.content_media_types?.STORY) === 0)) {
                deliverables_errors.content_media_types = "Atleast one content media type is required."
            }
        } else if (campaign?.campaign?.platform === 'yt') {
            if (isNaN(Number(campaignMilestone?.content_media_types?.VIDEO)) || Number(campaignMilestone?.content_media_types?.VIDEO) === 0 || Number(campaignMilestone.content_media_types.VIDEO) > 1) {
                deliverables_errors.content_media_types = "No of videos must be 1.";
            }
        }



        if (!campaignMilestone?.specifications?.quick_repost && (!Array.isArray(campaignMilestone.specifications?.cta) || campaignMilestone.specifications.cta.length < 1)) {
            deliverables_errors.cta = 'Please add atleast one CTA.'
        }

        if (campaignMilestone.specifications.dm_automation_required) {
            if (!campaignMilestone.specifications?.dm_automation_triggers || !Array.isArray(campaignMilestone.specifications.dm_automation_triggers) || campaignMilestone.specifications.dm_automation_triggers.length === 0) {
                deliverables_errors.dm_automation_triggers = "Please select atleast one trigger for DM automation.";
            }

            if (!campaignMilestone.specifications?.dm_automation_button_text || campaignMilestone.specifications.dm_automation_button_text.trim() === '') {
                deliverables_errors.dm_automation_button_text = "Please select button text for DM automation.";
            }

        }

        if (Array.isArray(campaignMilestone.specifications?.talking_points)) {
            for (let talkingPoint of campaignMilestone.specifications.talking_points) {
                if (!talkingPoint?.title || !Array.isArray(talkingPoint.pointers) || talkingPoint.pointers.length === 0) {
                    deliverables_errors.talking_points = "Incorrect/Incomplete talking points format!";
                }
            }
        }

        if (!campaignMilestone?.specifications?.quick_repost && campaign?.campaign?.goal === 'conversion' && !campaignMilestone.specifications.ad_rights_duration) {
            deliverables_errors.ad_rights_duration = "Please select Ad rights duration"
        }
        if (!campaignMilestone?.specifications?.quick_repost && !campaignMilestone.specifications.content_rights_duration) {
            deliverables_errors.content_rights_duration = "Please select content rights duration"
        }

        if (Object.keys(deliverables_errors).length > 0) {
            newErrors['deliverables'] = deliverables_errors;
        }

        const payments_errors: { [key: string]: string } = {};
        if (!campaignMilestone.gig_amount || isNaN(Number(campaignMilestone.gig_amount)) || Number(campaignMilestone.gig_amount) < 0) {
            payments_errors.gig_amount = 'Please enter a valid amount.'
        }

        if (!campaignMilestone.payment_days || isNaN(Number(campaignMilestone.payment_days)) || Number(campaignMilestone.payment_days) < 0) {
            payments_errors.payment_days = 'Please enter a valid number of days.'
        }

        if (Object.keys(payments_errors).length > 0) {
            newErrors['payment-terms'] = payments_errors;
        }

        if (Object.keys(newErrors).length > 0) {
            const result = await Swal.fire({
                title: "Incomplete details",
                text: "Please complete all required fields before submitting the campaign for approval.",
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Edit Campaign",
                cancelButtonText: "Got it",
                reverseButtons: true
            });

            if (result.isConfirmed) {
                navigate(`/campaign/${campaignId}/${Object.keys(newErrors)[0]}?validate=true`);
            }
            return false;
        }

        return true;
    }

    if (loading) {
        return <Loader />
    }

    return (
        <>
            <div className="campaign-page">
                <div className="row">
                    <div className="col-lg-8">
                        <div className="card overflow-hidden">
                            <CampaignImageSlider images={getSliderImages()} />
                            <div className="campaign-info p-4">
                                <div className="d-flex flex-column flex-md-row justify-content-between">
                                    <div className="campaign-basic-info d-flex gap-3">
                                        {
                                            campaign?.brand?.img_url ?
                                                <div className="detail-brand-logo bg-image bgc-white" style={{ backgroundImage: `url(${campaign?.brand?.img_url})` }}></div>
                                                : <Avatar name={campaign?.campaign?.name} size='50' maxInitials={1} round={'4px'} />
                                        }
                                        <div className="campaign-name-brand d-flex flex-column ">
                                            {
                                                (campaign?.brand || campaign?.campaign?.agency?.name) &&
                                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                                    {
                                                        campaign?.brand &&
                                                        <a href={campaign?.brand.website_url} className="campaign-brand-url" target="_blank" rel="noreferrer">{campaign?.brand.name} <span className="navigate-icon text-primary bg-primary-light"><i className="mdi mdi-arrow-top-right" /></span></a>
                                                    }
                                                    {
                                                        campaign?.campaign?.agency?.name &&
                                                        <span className="text-muted">{campaign.campaign.agency.name}</span>
                                                    }
                                                </div>
                                            }
                                            <span className="campaign-name-1 d-flex align-items-center gap-2">
                                                {
                                                    countryCode &&
                                                    <>
                                                        <span id="campaign-country-flag" className="d-inline-flex">
                                                            <FlagImage
                                                                iso2={countryOption?.iso2 || countryCode.toLowerCase()}
                                                                size="20px"
                                                            />
                                                        </span>
                                                        <UncontrolledTooltip
                                                            placement="top"
                                                            target="campaign-country-flag"
                                                            fade={false}
                                                        >
                                                            {countryOption?.label || countryCode.toUpperCase()}
                                                        </UncontrolledTooltip>
                                                    </>
                                                }
                                                {campaign?.campaign.name}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-end gap-2">
                                        <AccessControl privilege={PRIVILEGE.CAMPAIGN.CAMPAIGN.EDIT} ifCondition={!['completed', 'approved'].includes(campaign?.campaign?.status ?? '')}>
                                            <Link to={`/campaign/${campaign?.campaign.uuid}/edit`} className="btn btn-sm btn-primary-light campaign-edit-btn">Edit <i className="bx bx-edit" /></Link>
                                        </AccessControl>
                                        {/* <AccessControl privilege={PRIVILEGE.CAMPAIGN.CAMPAIGN.EDIT} ifCondition={(Number(campaign?.campaign?.version) >= 2 || milestones.length <= 1)}>
                                                <button onClick={copyToNewCampaign} className="btn btn-sm btn-outline-primary campaign-edit-btn w-auto">Copy to New Campaign <i className="bx bxs-copy-alt"></i></button>
                                            </AccessControl> */}
                                        <AccessControl privilege={PRIVILEGE.CAMPAIGN.CAMPAIGN.SHOW} ifCondition={['completed', 'approved'].includes(campaign?.campaign?.status ?? '')}>
                                            <button onClick={() => setShareWithCreatorsModalOpen(true)} className="btn btn-sm btn-soft-primary btn-border campaign-edit-btn w-auto">Share with Creators <i className="ri-share-forward-fill"></i></button>
                                        </AccessControl>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card p-3">
                            {
                                Number(campaign?.campaign?.version) >= 2 ? (
                                    <>
                                        <CampaignInfo viewOnly={true} />
                                        {
                                            milestones?.[0]?.gig_type.slug !== 'brand_promotion' ? (
                                                <CampaignProduct viewOnly={true} />
                                            ) : null
                                        }
                                        <CampaignDeliverables viewOnly={true} />
                                    </>
                                ) : (
                                    <>
                                        {/* <Nav pills fill>
                                                <NavItem onClick={() => setActiveTab('overview')}>
                                                    <NavLink active={activeTab === 'overview'}>
                                                        Overview
                                                    </NavLink>
                                                </NavItem>
                                                {
                                                    milestonesData?.milestones?.map((milestone, i) => (
                                                        <NavItem onClick={() => setActiveTab(`milestone-${i}`)}>
                                                            <NavLink key={i} href="#" active={activeTab === `milestone-${i}`}>
                                                                #{i + 1} {getGigType(milestone?.gig_type_id)?.name}
                                                            </NavLink>
                                                        </NavItem>
                                                    ))
                                                }
                                            </Nav>
                                            <TabContent activeTab={activeTab}>
                                                <TabPane tabId={'overview'}>
                                                    <div className='detail-card border-1 mt-4'>
                                                        <div className="detail-card-header py-4">
                                                            Description
                                                        </div>
                                                        <div className="detail-card-body p-4 bg-white">
                                                            <div className="niches-list d-flex justify-content-start align-items-center flex-wrap">
                                                                {
                                                                    campaign?.campaign.niche_names?.map((niche, i) => <span className="badge" key={i}>{niche}</span>)
                                                                }
                                                            </div>
                                                            <div className="campaign-description mt-3">
                                                                <div style={{ whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sanitizeURLs(campaign?.campaign?.description ?? ""), { ALLOWED_ATTR: allowedAttr, ALLOWED_TAGS: allowedTags }) }}></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        campaign?.brand &&
                                                        <div className='detail-card border-1 mt-4'>
                                                            <div className="detail-card-header py-4">
                                                                About Brand
                                                            </div>
                                                            <div className="detail-card-body p-4 bg-white">
                                                                {campaign?.brand.description}
                                                            </div>
                                                        </div>
                                                    }
                                                </TabPane>
                                                {
                                                    milestones?.map((milestone, i) => (
                                                        <TabPane tabId={`milestone-${i}`}>
                                                            <MilestoneForm
                                                                disabled={true}
                                                                milestone={milestone}
                                                                key={i}
                                                                activeMilestone={milestone}
                                                                handleMilestoneChange={() => noop}
                                                                errors={{}}
                                                                gigTypes={milestonesData?.gig_types ?? []}
                                                                milestoneGigType={milestonesData?.gig_types.find((g) => g.id === milestone.gig_type_id)!}
                                                                updateMilestone={(updatedMilestone) => {
                                                                    let updated_milestones = [...milestones];
                                                                    updated_milestones[i] = updatedMilestone;
                                                                    setMilestones(updated_milestones);
                                                                }}
                                                            />
                                                        </TabPane>

                                                    ))
                                                }
                                            </TabContent> */}

                                        <div className='detail-card border-1 mt-4 p-4'>
                                            <h6>
                                                This campaign version is not supported in this app.
                                            </h6>
                                        </div>
                                    </>
                                )
                            }

                        </div>

                    </div>
                    <div className="col-lg-4">
                        {
                            <>
                                <AccessControl privilege={PRIVILEGE.CAMPAIGN.CAMPAIGN.EDIT}>
                                    <React.Fragment>
                                        {
                                            campaign?.campaign?.status === 'draft' && <button onClick={sendForApproval} className="mb-3 theme-btn theme-btn-lg btn-gradient w-100 campaign-edit-btn d-flex justify-content-between">Send for Approval <i className='fs-3 bx bx-right-arrow-alt'></i></button>
                                        }
                                        {
                                            campaign?.campaign?.status === 'pending' && <button className="mb-3 btn btn-primary-light w-100 campaign-edit-btn d-flex justify-content-between">Sent for Approval <i className='fs-3 bx bx-time-five' ></i></button>
                                        }
                                    </React.Fragment>
                                </AccessControl>
                                <AccessControl privilege={PRIVILEGE.CAMPAIGN.CAMPAIGN.PROCESS}>
                                    {
                                        campaign?.campaign?.status === 'approved' && <button onClick={markCompleted} className="mb-3 theme-btn theme-btn-lg btn-gradient w-100 campaign-edit-btn d-flex justify-content-between">Mark Complete <CheckedIcon /></button>
                                    }
                                </AccessControl>
                            </>

                        }
                        <div className='detail-card border-1'>
                            <div className="detail-card-header py-4">
                                Creators Requirements
                            </div>
                            <div className="detail-card-body bg-white">
                                <div className="row g-0">
                                    <div className="col-6 p-0 border-bottom-1 border-right-1">
                                        <div className="ps-4 pe-3 py-3 d-flex justify-content-between align-items-center">
                                            <div className="d-flex flex-column align-items-start gap-1 justify-content-center">
                                                <span className="specification-value">
                                                    {campaign?.campaign.posted_on}
                                                </span>
                                                <span className="specification-title">
                                                    Posted On
                                                </span>
                                            </div>
                                            <span className="icon-circle"><CalendarIcon /></span>
                                        </div>
                                    </div>
                                    {/* <div className="col-6 p-0 border-bottom-1 border-right-1">
                                            <div className="ps-4 pe-3 py-3 d-flex justify-content-between align-items-center">
                                                <div className="d-flex flex-column align-items-start gap-1 justify-content-center">
                                                    <span className="specification-value text-success text-uppercase">
                                                        {campaign?.campaign.strategy}
                                                    </span>
                                                    <span className="specification-title">
                                                        Strategy
                                                    </span>
                                                </div>
                                                <span className="icon-circle"><StrategyIcon /></span>
                                            </div>
                                        </div> */}
                                    <div className="col-6 p-0 border-bottom-1 border-right-1">
                                        <div className="ps-4 pe-3 py-3 d-flex justify-content-between align-items-center">
                                            <div className="d-flex flex-column align-items-start gap-1 justify-content-center">
                                                <span className="specification-value">
                                                    {formatAmount(campaign?.campaign.budget, campaign?.campaign?.currency?.code, campaign?.campaign?.currency?.symbol, campaign?.campaign?.currency?.locale)}
                                                </span>
                                                <span className="specification-title">
                                                    Creator Budget
                                                </span>
                                            </div>
                                            <span className="icon-circle"><DollarIcon /></span>
                                        </div>
                                    </div>
                                    {
                                        (Number(campaign?.campaign?.barter_budget) > 0) &&
                                        <div className="col-6 p-0 border-bottom-1 border-right-1">
                                            <div className="ps-4 pe-3 py-3 d-flex justify-content-between align-items-center">
                                                <div className="d-flex flex-column align-items-start gap-1 justify-content-center">
                                                    <span className="specification-value">
                                                        {formatAmount(campaign?.campaign.barter_budget, campaign?.campaign?.currency?.code, campaign?.campaign?.currency?.symbol, campaign?.campaign?.currency?.locale)} <span>{campaign?.campaign?.barter_reimbursement ? '(Reimbursable)' : ''}</span>
                                                    </span>
                                                    <span className="specification-title">
                                                        Barter Amount
                                                    </span>
                                                </div>
                                                <span className="icon-circle"><DollarIcon /></span>
                                            </div>
                                        </div>
                                    }
                                    {
                                        (campaign?.campaign?.requirements?.age?.min ? true : false) &&
                                        <div className="col-6 p-0 border-bottom-1 border-right-1">
                                            <div className="ps-4 pe-3 py-3 d-flex justify-content-between align-items-center">
                                                <div className="d-flex flex-column align-items-start gap-1 justify-content-center">
                                                    <span className="specification-value">
                                                        {campaign?.campaign.requirements?.follower_count.min}+
                                                    </span>
                                                    <span className="specification-title">
                                                        Followers
                                                    </span>
                                                </div>
                                                <span className="icon-circle"><FollowersIcon /></span>
                                            </div>
                                        </div>
                                    }
                                    {
                                        campaign?.campaign?.requirements?.gender && campaign?.campaign?.requirements?.gender !== 'A' &&
                                        <div className="col-6 p-0 border-bottom-1 border-right-1">
                                            <div className="ps-4 pe-3 py-3 d-flex justify-content-between align-items-center">
                                                <div className="d-flex flex-column align-items-start gap-1 justify-content-center">
                                                    <span className="specification-value text-capitalize">
                                                        {campaign?.campaign.requirements?.gender_name}
                                                    </span>
                                                    <span className="specification-title">
                                                        Creator's Gender
                                                    </span>
                                                </div>
                                                <span className="icon-circle"><InfluencerIcon /></span>
                                            </div>
                                        </div>
                                    }
                                    {
                                        campaign?.campaign?.requirements?.audience_gender && campaign?.campaign?.requirements?.audience_gender !== 'A' &&
                                        <div className="col-6 p-0 border-bottom-1 border-right-1">
                                            <div className="ps-4 pe-3 py-3 d-flex justify-content-between align-items-center">
                                                <div className="d-flex flex-column align-items-start gap-1 justify-content-center">
                                                    <span className="specification-value text-capitalize">
                                                        {campaign?.campaign.requirements?.audience_gender_name}
                                                    </span>
                                                    <span className="specification-title">
                                                        Audience Gender
                                                    </span>
                                                </div>
                                                <span className="icon-circle"><InfluencerIcon /></span>
                                            </div>
                                        </div>
                                    }
                                    {
                                        extraColumnRequired() &&
                                        <div className="col-6 p-0 border-bottom-1 border-right-1"></div>
                                    }
                                    {
                                        campaign?.campaign?.requirements?.regions && campaign?.campaign?.requirements?.regions.length > 0 &&
                                        <div className="col-12 border-bottom-1 border-right-1">
                                            <div className="ps-4 pe-3 py-3 d-flex justify-content-between align-items-center">
                                                <div className="d-flex flex-column align-items-start gap-1 justify-content-center">
                                                    <span className="specification-title">
                                                        Creator Region(s)
                                                    </span>
                                                    <div className="d-flex justify-content-start align-items-center gap-3 flex-wrap">
                                                        {
                                                            campaign?.campaign?.requirements?.regions.map((region, i) => {
                                                                return (
                                                                    <div className="badge" key={i}>{region}</div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                                <span className="icon-circle"><LocationIcon /></span>
                                            </div>
                                        </div>
                                    }
                                    {
                                        campaign?.campaign?.requirements?.cities && campaign?.campaign?.requirements?.cities.length > 0 &&
                                        (!Array.isArray(campaign?.campaign?.requirements?.regions) || campaign?.campaign?.requirements?.regions.length === 0) &&
                                        <div className="col-12 border-bottom-1 border-right-1">
                                            <div className="ps-4 pe-3 py-3 d-flex justify-content-between align-items-center">
                                                <div className="d-flex flex-column align-items-start gap-1 justify-content-center">
                                                    <span className="specification-title">
                                                        Creator Location(s)
                                                    </span>
                                                    <div className="d-flex justify-content-start align-items-center gap-3 flex-wrap">
                                                        {
                                                            campaign?.campaign?.requirements?.cities.map((city, i) => {
                                                                return (
                                                                    <div className="badge" key={i}>{city}</div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                                <span className="icon-circle"><LocationIcon /></span>
                                            </div>
                                        </div>
                                    }
                                    {
                                        campaign?.campaign?.requirements?.audience_cities && campaign?.campaign?.requirements?.audience_cities.length > 0 &&
                                        <div className="col-12 border-bottom-1 border-right-1">
                                            <div className="ps-4 pe-3 py-3 d-flex justify-content-between align-items-center">
                                                <div className="d-flex flex-column align-items-start gap-1 justify-content-center">
                                                    <span className="specification-title">
                                                        Audience Location(s)
                                                    </span>
                                                    <div className="d-flex justify-content-start align-items-center gap-3 flex-wrap">
                                                        {
                                                            campaign?.campaign?.requirements?.audience_cities.map((city, i) => {
                                                                return (
                                                                    <div className="badge" key={i}>{city}</div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                                <span className="icon-circle"><LocationIcon /></span>
                                            </div>
                                        </div>
                                    }
                                    {
                                        campaign?.campaign?.requirements?.audience_age_groups && campaign?.campaign?.requirements?.audience_age_groups.length > 0 &&
                                        <div className="col-12 border-bottom-1 border-right-1">
                                            <div className="ps-4 pe-3 py-3 d-flex justify-content-between align-items-center">
                                                <div className="d-flex flex-column align-items-start gap-1 justify-content-center">
                                                    <span className="specification-title">
                                                        Audience Age Group(s)
                                                    </span>
                                                    <div className="d-flex justify-content-start align-items-center gap-3 flex-wrap">
                                                        {
                                                            campaign?.campaign?.requirements?.audience_age_groups.map((age_group, i) => {
                                                                return (
                                                                    <div className="badge" key={i}>{age_group}</div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                                <span className="icon-circle"><BirthdayIcon /></span>
                                            </div>
                                        </div>
                                    }
                                    {
                                        campaign?.campaign?.requirements?.languages && campaign?.campaign?.requirements?.languages.length > 0 &&
                                        <div className="col-12 border-bottom-1 border-right-1">
                                            <div className="ps-4 pe-3 py-3 d-flex justify-content-between align-items-center">
                                                <div className="d-flex flex-column align-items-start gap-1 justify-content-center">
                                                    <span className="specification-title">
                                                        Languages
                                                    </span>
                                                    <div className="d-flex justify-content-start align-items-center gap-3 flex-wrap">
                                                        {
                                                            campaign?.campaign?.requirements?.languages.map((lang, i) => {
                                                                return (
                                                                    <div className="badge" key={i}>{languages[lang] ?? '-'}</div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                                <span className="icon-circle"><LanguagesIcon /></span>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        {/* {
                            campaign?.campaign?.status && !['pending', 'draft'].includes(campaign.campaign.status) &&
                            <AccessControl privilege={PRIVILEGE.CAMPAIGN.PERFORMANCE.INDEX}>
                                <Link to={`/campaign/${campaignId}/insights`} className="btn btn-primary-light w-100 mt-3 campaign-edit-btn d-flex justify-content-between">View Insights <ChartsIcon /> </Link>
                            </AccessControl>
                        } */}
                    </div>
                </div>
            </div>
            <Modal centered isOpen={shareWithCreatorsModalOpen} toggle={() => setShareWithCreatorsModalOpen(false)}>
                <ModalHeader toggle={() => setShareWithCreatorsModalOpen(false)} className="border-bottom py-2">
                    Share with Creators
                </ModalHeader>
                <ModalBody>
                    <p> Share this campaign link with creators to let them explore and apply for it.</p>
                    <InputGroup>
                        <Input
                            disabled={true}
                            type="text"
                            id="campaign-link"
                            className="form-control"
                            value={CREATOR_APP_URL + `/c/${campaign?.campaign.uuid}`} />

                        <Button title="Copy to clipboard" className="theme-btn theme-btn-lg btn-gradient" style={{ marginLeft: '-5px', height: '38px' }} onClick={() => {
                            copyToClipboard(CREATOR_APP_URL + `/c/${campaign?.campaign.uuid}`)
                            setCampaignLinkCopied(true);
                        }}>
                            {
                                campaignLinkCopied ? <i className="bx bx-check"></i> : <i className="bx bx-copy"></i>
                            }
                        </Button>

                    </InputGroup>
                </ModalBody>
                <ModalFooter className="border-top py-2">
                    <Button className="btn btn-gradient" onClick={() => setShareWithCreatorsModalOpen(false)}>Close</Button>
                </ModalFooter>
            </Modal>
        </>

    )
}

export default withAccessControl(Campaign, PRIVILEGE.CAMPAIGN.CAMPAIGN.SHOW)